import { Button, Card, CardContent, Drawer, FormControlLabel, Radio, RadioGroup, Typography, stepButtonClasses } from "@mui/material";
import { useEffect, useState } from "react";
const Permission = ({ data = {}, onChange = () => { }, current = {} }) => {
    const [openDrawrPrivacy, setOpenDrawrPrivacy] = useState(false);
    const [privacyDescription, setPrivacyDescription] = useState("");
    useEffect(()=>{
        (data.permessi||[]).map((p,idx) => {
            if(p.tipologia === "EXTERNAL" && p.chiave==="privacy"){
                setPrivacyDescription(p.descrizione);
            }
        });
    },[]);
    return <div className="permission-form">
        {data.permessi &&
            data.permessi.map((p,idx) => {
                return <Card key={`p_${idx}`} style={{ marginLeft: '1rem', marginRight: '1rem', marginBottom: '1rem', overflow: "unset" }}>
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            {p.titolo}
                        </Typography>
                        {p.tipologia === "PERMISSION" && <Typography variant="body2" color="text.secondary">
                            {p.descrizione || ""}
                        </Typography>
                        }
                        {
                            p.tipologia === "PERMISSION" &&
                            <>
                                <RadioGroup name={`${p.chiave}`} onChange={onChange} value={current[p.chiave] ? "S" : "N"}>
                                    <FormControlLabel value="S" control={<Radio />} label={p.configurazione.accept} />
                                    <FormControlLabel value="N" control={<Radio />} label={p.configurazione.deny} />
                                </RadioGroup>

                            </>
                        }
                        {
                            p.tipologia === "EXTERNAL" &&
                            <>
                                <div style={{ textAlign: 'center' }}>
                                    <Button variant="contained" style={{ marginTop: '10px' }} onClick={() => {
                                        setOpenDrawrPrivacy(true)
                                    }}>VISUALIZZA</Button>

                                </div>
                            </>

                        }

                    </CardContent>
                </Card>


            })
        }
        {
            openDrawrPrivacy && <div className="privacyDrawerContent" style={{ padding: '1rem' }} >
                <div style={{ overflow: 'hidden', overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: privacyDescription }}>

                </div>
                <div style={{ padding: '10px' }}>
                    <Button variant="contained" style={{ width: '100%' }} onClick={() => {
                        setOpenDrawrPrivacy(false)
                    }}>OK</Button>
                </div>
            </div>

        }
    </div>
}
export default Permission;

